/**
 * Simplified Chinese (zh-CN) — translation file
 * All keys use flat namespace.key format
 */
export const zhCN: Record<string, string> = {
  // ── Menu Scenes ──────────────────────────────────────────
  'menu.play_game': '开始游戏',
  'menu.version': 'v0.1.0 - PHASER 迁移版',
  'menu.back_to_menu': '返回菜单',

  // ── Options ──────────────────────────────────────────────
  'options.title': '设置',
  'options.graphics': '画面',
  'options.audio': '音频',
  'options.gameplay': '玩法',
  'options.language': '语言',
  'options.resolution': '分辨率：',
  'options.quality': '画质：',
  'options.fullscreen': '全屏',
  'options.autosave': '自动保存',
  'options.show_tooltips': '显示提示',
  'options.master_volume': '主音量',
  'options.music_volume': '音乐音量',
  'options.sfx_volume': '音效音量',
  'options.difficulty': '难度：',
  'options.select_language': '选择语言',

  // ── Login ────────────────────────────────────────────────
  'login.brand_crimson': '绯红',
  'login.brand_mandate': '令权',
  'login.tagline': '采矿\u2022贸易\u2022征服\u2022赚取USDC',
  'login.version': '绯红令权 v0.1.0',
  'login.enter_email': '输入邮箱',
  'login.email_placeholder': 'commander@fleet.com',
  'login.enter_password': '输入密码',
  'login.password_placeholder': '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
  'login.remember_me': '记住我',
  'login.conquer_galaxy': '征服银河',
  'login.connecting': '连接中...',
  'login.forgot_password': '忘记密码？',
  'login.create_account': '创建账号 >',
  'login.password_reset_soon': '密码重置功能即将推出',
  'login.shop_banner': '购买战舰需要账号。请先登录或在下方创建账号。',
  'login.enter_email_password': '请输入邮箱和密码',
  'login.server_unavailable': '服务器暂不可用，请稍后重试。',
  'login.login_failed': '登录失败',
  'login.connection_failed': '连接失败',
  'login.unknown_error': '未知错误',

  // ── Register ─────────────────────────────────────────────
  'register.commander_name': '指挥官名称',
  'register.username_placeholder': '星际船长',
  'register.email_address': '邮箱地址',
  'register.password': '密码',
  'register.confirm_password': '确认密码',
  'register.create_commander': '创建指挥官',
  'register.creating': '创建中...',
  'register.back_to_login': '< 返回登录',
  'register.strength_length': '\u2298 至少8个字符',
  'register.strength_number': '\u2298 包含数字',
  'register.strength_symbol': '\u2298 包含符号',
  'register.passwords_match': '\u2713 密码一致',
  'register.passwords_no_match': '\u2717 密码不一致',
  'register.fill_all_fields': '请填写所有字段',
  'register.name_too_short': '指挥官名称至少需要3个字符',
  'register.password_too_short': '密码至少需要8个字符',
  'register.passwords_mismatch': '两次密码不一致',
  'register.account_created_login': '账号已创建！正在登录...',
  'register.account_created_connect': '账号已创建！正在连接...',
  'register.connection_failed': '账号已创建，但连接游戏超时。请刷新页面或重新登录。',
  'register.registration_failed': '注册失败',

  // ── HUD Top Bar ──────────────────────────────────────────
  'hud.logo': '绯红\n令权',
  'hud.menu': '\u2630 菜单',

  // ── Nav Buttons ──────────────────────────────────────────
  'nav.wreck': '残骸',
  'nav.insure': '保险',
  'nav.trade': '交易',
  'nav.ore': '矿石',
  'nav.crew': '船员',
  'nav.parts': '配件',
  'nav.shop': '商店',
  'nav.buy_isd': '购买ISD',
  'nav.station': '空间站',
  'nav.center': '居中',
  'nav.follow': '跟随',
  'nav.research': '研究',
  'nav.tech': '科技',
  'nav.alliance_hq': '联盟总部',
  'nav.refund': '回购',
  'nav.withdraw': '提现',

  // ── Disconnect Overlay ───────────────────────────────────
  'disconnect.title': '连接已断开',
  'disconnect.idle': '因长时间未操作已断开连接。',
  'disconnect.reconnecting': '重新连接中... ({attempt}/{max})',
  'disconnect.failed': '重新连接失败。',
  'disconnect.reconnect': '重新连接',

  // ── Dialog Titles ────────────────────────────────────────
  'dialog.menu': '菜单',
  'dialog.ship_store': '战舰商店',
  'dialog.components': '组件',
  'dialog.ore_inventory': '矿石仓库',
  'dialog.wreckage': '残骸',
  'dialog.insurance': '保险',
  'dialog.stations': '空间站',
  'dialog.crew_quarters': '船员舱',
  'dialog.trade_hub': '贸易中心',
  'dialog.browse_alliances': '浏览联盟',
  'dialog.alliance_hq': '联盟总部',
  'dialog.commander_profile': '指挥官档案',
  'dialog.refund': '回购',
  'dialog.relic_inventory': '遗物仓库',
  'dialog.tech_database': '科技数据库',
  'dialog.buy_isd': '购买 $ISD',
  'dialog.ship_modification': '战舰改装',
  'dialog.while_away': '离线期间',
  'dialog.research_board': '公共研究板',
  'dialog.component_enhancement': '组件强化',
  'dialog.alliance': '联盟',
  'dialog.create_alliance': '创建联盟',
  'dialog.alliance_management': '联盟管理',
  'dialog.direct_messages': '私信',
  'dialog.battle_report': '战斗报告',
  'dialog.build_ship': '建造战舰 \u2014 {planetName}',
  'dialog.pirate_faction': '海盗势力',
  'dialog.player_profile': '玩家档案',
  'dialog.ship_details': '战舰详情',
  'dialog.component_loadout': '组件装配',
  'dialog.repair_component': '维修组件',

  // ── Resource Display ─────────────────────────────────────
  'resource.title': '资源',
  'resource.credits': 'ISD',
  'resource.minerals': '矿物',
  'resource.rare_metals': '稀有金属',
  'resource.tech_data': '科技数据',
  'resource.salvage': '打捞物',
  'resource.exotic_matter': '奇异物质',

  // ── Left Sidebar ─────────────────────────────────────────
  'sidebar.empire_status': '帝国状态',
  'sidebar.stations': '空间站',
  'sidebar.ships': '战舰',
  'sidebar.explored': '已探索',
  'sidebar.explored_hexes': '{count} 格',
  'sidebar.credit': '信用点',
  'sidebar.fleet': '舰队',
  'sidebar.missions': '任务',
  'sidebar.no_ships': '暂无已部署的战舰',
  'sidebar.no_stations': '暂无已部署的空间站',
  'sidebar.planet': '行星',
  'sidebar.station_label': '空间站',
  'sidebar.docked': '已停靠',
  'sidebar.docked_at': '\u2693 {location}',
  'sidebar.moving': '移动中 ({turns}回合)',
  'sidebar.hp_percent': '生命 {pct}%',
  'sidebar.cargo': '货舱 {used}/{cap}',
  'sidebar.no_missions': '暂无可用\n任务',
  'sidebar.coming_soon': '即将推出',

  // ── Right Panel (Alliance) ───────────────────────────────
  'alliance.title': '联盟',
  'alliance.members': '{count} 名成员',
  'alliance.online': '{count} 人在线',
  'alliance.view': '查看',
  'alliance.message': '消息',
  'alliance.create': '创建',
  'alliance.browse': '浏览',

  // ── Chat Panel ───────────────────────────────────────────
  'chat.tab_chat': '聊天',
  'chat.tab_log': '日志',
  'chat.channel_alliance': '联盟',
  'chat.channel_global': '全服',
  'chat.placeholder': '输入消息...',
  'chat.me': '我',
  'chat.title': '通讯',
  'chat.no_messages': '暂无消息。\n请在下方输入开始聊天。',
  'chat.log_initialized': '活动日志已初始化',

  // ── Command Dock ─────────────────────────────────────────
  // Action buttons
  'action.move': '移动',
  'action.attack': 'ENGAGE',
  'action.dock': '停靠',
  'action.undock': '解除停靠',
  'action.mine': '采矿',
  'action.stop': '停止',
  'action.repair': '维修',
  'action.modify': '改装',
  'action.goto': '前往',
  'action.return': '返回',
  'action.cancel': '取消',
  'action.rename': '重命名',
  'action.paint': '涂装',
  'action.sensor_boost': '传感器增强',
  'action.warp': '跃迁',
  'action.beacon': '信标',
  'action.deliver': '优先配送',
  'action.pick_color': '选择颜色',
  'action.select_ship_attack': '选择攻击目标',
  'action.select_ship_move': '选择移动目标',

  // Action tooltips
  'tooltip.move': '将战舰移动至目标格',
  'tooltip.attack': '攻击敌方战舰',
  'tooltip.dock': '停靠在行星或空间站',
  'tooltip.undock': '从当前位置解除停靠',
  'tooltip.mine': '从小行星采集矿物',
  'tooltip.stop_mine': '停止采矿',
  'tooltip.repair': '使用货舱矿物维修船体',
  'tooltip.repair_full': '单位已满血',
  'tooltip.modify': '在船坞改装战舰组件',
  'tooltip.modify_dock': '停靠至空间站以改装战舰',
  'tooltip.goto': '导航至指定坐标',
  'tooltip.return_to_base': '返回最近的友方空间站并自动停靠',
  'tooltip.mine_minerals': '采集矿物...',
  'tooltip.mine_stellar': '采集黄金...',
  'tooltip.mine_move_adjacent': '移动至小行星旁边以进行采矿',
  'tooltip.dock_no_target': '移动至行星或空间站1格内以停靠',
  'tooltip.dock_no_range': '停靠范围内无行星或空间站',
  'tooltip.dock_disabled': '无法在此停靠',
  'tooltip.undock_move': '解除停靠后移动',
  'tooltip.repair_hull': '修复船体',
  'tooltip.full_health': '满血',
  'tooltip.modify_components': '修改组件',
  'tooltip.dock_to_modify': '停靠后才能修改',
  'tooltip.speed': '速度',
  'tooltip.attack_stat': '攻击',
  'tooltip.defense': '防御',
  'tooltip.range': '射程',
  'tooltip.hull_integrity': '船体完整性',
  'tooltip.shields_desc': '护盾描述',
  'tooltip.sensor_sweep': '传感器扫描',
  'tooltip.evasive_maneuvers': '规避机动',
  'tooltip.afterburner': '加速器',
  'tooltip.missile_barrage': '导弹齐射',
  'tooltip.broadside': '侧舷齐射',
  'tooltip.shield_overcharge': '护盾过载',
  'tooltip.emergency_jump': '紧急跃迁',
  'tooltip.richness': '丰富度',
  'tooltip.remaining_ore': '剩余矿石',
  'tooltip.rarity': '稀有度',
  'tooltip.asteroid_stellar': '含有加密货币',
  'tooltip.asteroid_no_stellar': '无加密货币',
  'tooltip.planet_structural': '行星结构完整性',
  'tooltip.station_structural': '空间站结构完整性',
  'tooltip.mineral_storage': '矿物存储',
  'tooltip.docked_planet': '停靠在行星',
  'tooltip.docked_station': '停靠在空间站',
  'tooltip.fee_earth': '地球手续费',
  'tooltip.fee_station': '空间站手续费',
  'tooltip.planet_status': '行星状态',
  'tooltip.station_status': '空间站状态',

  // Stat labels
  'stat.health': '生命',
  'stat.shields': '护盾',
  'stat.speed': '速度',
  'stat.attack': '攻击',
  'stat.defense': '防御',
  'stat.range': '射程',
  'stat.storage': '容量',
  'stat.docked': '已停靠',
  'stat.fee': '手续费',
  'stat.status': '状态',
  'stat.active': '活跃',
  'storage.label': '存储',

  // Stat tooltips
  'stat_tip.health': '当前船体完整度',
  'stat_tip.shields': '能量护盾强度',
  'stat_tip.movement': '每回合移动格数',
  'stat_tip.attack': '武器伤害输出',
  'stat_tip.defense': '伤害减免',
  'stat_tip.range': '最大武器射程',

  // Abilities
  'ability.scan': '扫描',
  'ability.evade': '闪避',
  'ability.boost': '加速',
  'ability.volley': '齐射',
  'ability.broad': '侧舷',
  'ability.shield': '护盾',
  'ability.jump': '跃迁',
  'ability.none': '无技能',

  'ability_tip.scan': '扫描周边区域',
  'ability_tip.evade': '进入闪避飞行模式',
  'ability_tip.boost': '加速引擎',
  'ability_tip.volley': '同时发射所有武器',
  'ability_tip.broad': '发射侧舷火炮',
  'ability_tip.shield': '过载护盾发生器',
  'ability_tip.jump': '启动曲速跃迁',

  // Tabs (ship)
  'tab.actions': '操作',
  'tab.abilities': '技能',
  'tab.cargo': '货舱 {used}/{cap}',
  'tab.crew': '船员',
  'tab.upgrades': '升级',

  // Tabs (planet)
  'tab.storage': '仓库',
  'tab.stellar': '黄金',
  'tab.build': '建造',

  // Tabs (station)
  'tab.manage': '管理',

  // Cargo
  'cargo.full_tooltip': '货舱已满！停靠至行星或空间站卸货。',
  'cargo.loading': '加载货物中...',
  'cargo.empty': '货舱为空',

  // Storage
  'storage.loading': '加载仓库中...',
  'storage.empty': '暂无存储的矿物',
  'storage.stellar_stored': '已存储黄金',
  'storage.buy_ship': '购买战舰',
  'storage.buy_parts': '购买配件',
  'storage.buy_crew': '招募船员',

  // Asteroid
  'asteroid.richness': '丰富度',
  'asteroid.rarity': '稀有度',
  'asteroid.stellar': '黄金',
  'asteroid.composition': '矿物成分',
  'asteroid.no_mineral_data': '无矿物数据',
  'asteroid.remaining_ore': '剩余矿石',
  'asteroid.stellar_label': '加密货币',
  'asteroid.legendary': '传说级',
  'asteroid.very_rich': '极丰富',
  'asteroid.rich': '丰富',
  'asteroid.moderate': '中等',
  'asteroid.poor': '贫瘠',
  'asteroid.suffix': ' 小行星',

  // Richness tiers
  'richness.legendary': '传说',
  'richness.very_rich': '极丰富',
  'richness.rich': '丰富',
  'richness.moderate': '中等',
  'richness.poor': '贫瘠',

  // Rarity tiers
  'rarity.legendary': '传说',
  'rarity.epic': '史诗',
  'rarity.rare': '稀有',
  'rarity.uncommon': '优良',
  'rarity.common': '普通',

  // Asteroid richness tooltips
  'asteroid_tip.richness': '矿物浓度品质',
  'asteroid_tip.rarity': '该小行星的稀有程度',
  'asteroid_tip.stellar': '拖至地球可获得的黄金收益',

  // Asteroid variant names
  'asteroid_variant.gold': '黄金',
  'asteroid_variant.platinum': '铂金',
  'asteroid_variant.dark_matter': '暗物质',

  // Minerals
  'mineral.iron': '铁',
  'mineral.copper': '铜',
  'mineral.titanium': '钛',
  'mineral.platinum': '铂',
  'mineral.rhodium': '铑',
  'mineral.palladium': '钯',
  'mineral.iridium': '铱',
  'mineral.dark_matter': '暗物质',
  'mineral.rare': '稀有',
  'mineral.common': '普通',
  'mineral.epic': '史诗',
  'mineral.uncommon': '罕见',

  // Wreck
  'wreck.suffix': ' 残骸',
  'wreck.time_left': '剩余时间（小时）',
  'wreck.type': '类型',
  'wreck.tow': '拖曳',
  'wreck.repair_label': '维修',
  'wreck.your_wreck': '你的残骸',
  'wreck.manage': '管理',
  'wreck.being_towed': '拖曳中',
  'wreck.being_repaired': '维修中',
  'wreck.claimed': '已认领',
  'wreck.claim': '认领',
  'wreck.repair': '修复',

  // Enemy / Unit
  'unit.you': '（你）',
  'unit.enemy': '敌方',
  'unit.loading': '加载中...',
  'unit.no_ships': '你没有战舰',
  'unit.select_attack': '选择要攻击的战舰',
  'unit.select_move': '选择要移动的战舰',

  // Enemy actions
  'enemy.player': '玩家',
  'enemy.ship': '战舰',
  'enemy.message': '消息',
  'enemy.move_to': '移动至',
  'enemy.badge': '敌人',

  // Planet
  'planet.home': '\u2605 母星',
  'planet.neutral': '中立',
  'planet.your_planet': '你的行星',
  'planet.docked': '已停靠',
  'planet.fee': '费用',
  'planet.status': '状态',
  'planet.active': '运行中',
  'planet.nothing_producing': '无生产任务',
  'planet.no_production': '无生产',
  'planet.done': '已完成',
  'planet.in_progress': '进行中',
  'planet.more_queued': '还有 {n} 项排队中',
  'planet.produce_ship': '生产战舰',
  'planet.produce_ship_tooltip': '在此行星建造新战舰',

  // Station
  'station.waypoint': '航标站',
  'station.depot': '补给站',
  'station.fortress': '堡垒站',
  'station.capital': '首都站',
  'station.your_station': '你的空间站',
  'station.stored_asteroids': '已存储的小行星',
  'station.docking_fee': '停靠费用',
  'station.manage_station': '管理空间站',
  'station.manage_tooltip': '打开空间站管理面板',
  'station.produce_tooltip': '在此空间站建造新战舰',
  'station.enemy': '敌方',
  'station.nothing_producing': '无生产中',
  'station.no_production': '无生产',
  'station.done': '完成',
  'station.in_progress': '进行中',
  'station.produce_ship': '生产舰船',

  // Upgrades / Burn sinks
  'upgrade.rename': '改名',
  'upgrade.rename_prompt': '输入新舰名（最多20个字符）：',
  'upgrade.rename_tooltip': '为战舰命名（100 ISD）',
  'upgrade.paint': '涂装',
  'upgrade.paint_tooltip': '更改战舰颜色（100 ISD）',
  'upgrade.sensor': '传感器+',
  'upgrade.sensor_tooltip': '扩展传感器范围1格（500 ISD）',
  'upgrade.warp': '跃迁',
  'upgrade.warp_soon': '跃迁跳跃：坐标选择功能即将推出',
  'upgrade.warp_tooltip': '解锁跃迁跳跃技能（2000 ISD）',
  'upgrade.beacon': '信标',
  'upgrade.beacon_no_alliance': '必须加入联盟才能放置信标',
  'upgrade.beacon_tooltip': '在当前位置放置舰队信标（200 ISD）',
  'upgrade.deliver': '优先',
  'upgrade.deliver_tooltip': '标记拖曳优先级（300 ISD）',
  'upgrade.pick_color': '选择颜色',

  // Paint colors
  'color.red': '红色',
  'color.green': '绿色',
  'color.blue': '蓝色',
  'color.yellow': '黄色',
  'color.pink': '粉色',
  'color.cyan': '青色',
  'color.orange': '橙色',
  'color.white': '白色',

  // GOTO popup
  'goto.q': 'Q',
  'goto.r': 'R',
  'goto.go': '前往',

  // Ship types
  'ship.scout': '侦察舰',
  'ship.fighter': '战斗机',
  'ship.destroyer': '驱逐舰',
  'ship.bomber': '轰炸机',
  'ship.trade_ship': '运输舰',
  'ship.cruiser': '巡洋舰',
  'ship.carrier': '航母',
  'ship.battleship': '战列舰',
  'ship.dreadnought': '无畏舰',
  'ship.titan': '泰坦',
  'ship.space_tug': '太空拖船',
  'ship.alien_leviathan': '外星巨兽',

  // Ship roles
  'role.recon': '侦察',
  'role.light_combat': '轻型作战',
  'role.strike': '突击',
  'role.heavy_strike': '重型突击',
  'role.logistics': '后勤',
  'role.heavy_combat': '重型作战',
  'role.fleet_support': '舰队支援',
  'role.assault': '强袭',
  'role.capital': '旗舰级',
  'role.flagship': '旗舰',

  // Ship store
  'store.credits': 'ISD：{n}',
  'store.loading_prices': '加载战舰价格中...',
  'store.load_failed': '价格加载失败，请稍后重试。',
  'store.buy_ship': '购买舰船',
  'store.buy_parts': '购买部件',
  'store.buy_crew': '招募船员',

  // Component categories
  'comp.all': '全部',
  'comp.weap': '武器',
  'comp.eng': '引擎',
  'comp.shld': '护盾',
  'comp.armr': '装甲',
  'comp.snsr': '传感',
  'comp.rctr': '反应堆',
  'comp.spec': '特殊',

  // Component tiers
  'tier.mk1': 'Mk I',
  'tier.mk2': 'Mk II',
  'tier.mk3': 'Mk III',
  'tier.mk4': 'Mk IV',
  'tier.proto': '原型',
  'tier.basic': '基础',
  'tier.improved': '改良',
  'tier.advanced': '高级',
  'tier.elite': '精英',
  'tier.experimental': '实验型',

  // Component stats
  'comp_stat.hull_hp': '船体生命',
  'comp_stat.shields': '护盾',
  'comp_stat.armor': '装甲',
  'comp_stat.speed': '速度',
  'comp_stat.evasion': '闪避',
  'comp_stat.sensor_range': '传感范围',
  'comp_stat.accuracy': '命中',
  'comp_stat.attack': '攻击',
  'comp_stat.defense': '防御',
  'comp_stat.power_output': '功率输出',
  'comp_stat.cooldown_reduc': '冷却缩减',
  'comp_stat.shield_regen': '护盾回复',
  'comp_stat.damage': '伤害',
  'comp_stat.fire_rate': '射速',

  // Hamburger menu
  'hamburger.audio': '音频',
  'hamburger.master': '主音量',
  'hamburger.music': '音乐',

  // Tutorial hint panel
  'tutorial.dismiss': 'X',
  'tutorial.skip': '跳过',

  // Number formatting
  'format.millions': 'M',
  'format.thousands': 'K',

  // FTUE hints (from server, but client can also use for display)
  'ftue.brand_new': '欢迎，指挥官！点击你的侦察舰来选中它。',
  'ftue.first_select': '很好！现在右键点击附近的格子来移动侦察舰。',
  'ftue.first_move': '正在移动！探索地图吧——暗色区域尚未发现。',
  'ftue.explore_vision': '找到一颗小行星，点击采矿来采集矿物。',
  'ftue.first_mine': '采矿成功！停靠至地球卸下你的货物。',
  'ftue.first_dock': '试试打开战舰商店，看看可购买的战舰。',
  'ftue.understand_hud': '使用顶部按钮购买战舰、交易等！',
  'ftue.first_purchase': '你已准备好征服星辰！教程完成。',

  // Welcome asteroid
  'ftue.welcome_asteroid': '附近出现了一颗欢迎礼物小行星！采矿以领取你的奖励。',
  'asteroid.welcome_gift': '欢迎礼物',
  'notification.welcome_claimed': '欢迎奖励已领取！',

  // ── Mineral Inventory Dialog ──────────────────────────────
  'ore.browse_trade': '浏览交易中心',
  'ore.total_mined': '总采集量',
  'ore.base_value': '基础价值',
  'ore.market_data': '市场数据',
  'ore.lowest': '最低',
  'ore.average': '平均',
  'ore.highest': '最高',
  'ore.active_listings': '活跃挂单',
  'ore.no_listings': '暂无挂单',
  'ore.sell': '出售',
  'ore.select_location': '选择一个位置查看矿物',
  'ore.total_minerals': '矿物总量',
  'ore.mineral_types': '矿物种类',
  'ore.stored_minerals': '存储矿物',
  'ore.est_value': '估值（基础）',
  'ore.in_inventory': '库存中',
  'ore.tab_all': '全部',
  'ore.tab_by_location': '按位置',

  // ── How To Guide ──────────────────────────────────────────
  'howto.title': '游戏攻略',
  'howto.skip': '跳过',
  'howto.next': '下一步',
  'howto.back': '上一步',
  'howto.done': '完成',
  'howto.launch': '启动 ▶',
  'howto.page1_title': '欢迎，指挥官',
  'howto.page1_bullet1': '你的舰队，你的领地。一个每个行动都留下印记的持久银河。',
  'howto.page1_bullet2': '建造战舰、采矿船和侦察船。在群星中宣示你的主权。',
  'howto.page2_title': '探索未知',
  'howto.page2_bullet1': '移动到一个六角格进行探索。传感器揭示附近空间——其余是黑暗。',
  'howto.page2_bullet2': '靠近地球更安全。越远越丰富（也越危险）。',
  'howto.page3_title': '建立帝国',
  'howto.page3_bullet1': '开采小行星获取资源——铁、铂金，甚至暗物质。',
  'howto.page3_bullet2': '在空间站停靠以卸货、修复和升级舰队。',
  'howto.page4_title': '夺取他们的资源',
  'howto.page4_bullet1': '攻击对手，打捞残骸，夺取战利品。',
  'howto.page4_bullet2': '突袭敌方空间站，控制贸易航线。',
  'howto.page5_title': '自由选择',
  'howto.page5_bullet1': '加入联盟共享研究、领地和力量——或独自行动。',
  'howto.page5_bullet2': '选择成为矿工、海盗、大亨或舰队指挥官。由你决定。',
  'howto.page6_title': '未知等待着你',
  'howto.page6_bullet1': '在深空发现外星遗物、加密体和利维坦。',
  'howto.page6_bullet2': '银河浩瀚。如何征服它取决于你。',
  'nav.how_to': '攻略',
  'dialog.how_to': '游戏攻略',

  // ── Platforms ────────────────────────────────────────────
  'platform.basic': '基础平台',
  'platform.advanced': '高级平台',
  'platform.elite': '精英平台',
  'platform.legendary': '传说平台',
  'platform.deploy': '部署平台',
  'platform.relocate': '重新部署平台',
  'platform.manage': '管理平台',
  'platform.purchase': '购买平台',
  'platform.mining_yield': '轨道采矿产量',
  'platform.storage': '平台存储',
  'platform.capabilities': '能力',
  'platform.dock': '停靠港',
  'platform.repair': '维修港',
  'platform.shipyard': '造船厂',
  'platform.build': '单位建造',
  'platform.mining': '轨道采矿',
  'platform.earth_station': '地球轨道站',
  'platform.public': '公共平台',
  'planet.resources': '行星资源',
  'planet.depleted': '已耗尽',
  'planet.remaining': '剩余',
  'commanddock.dock_platform': '停靠平台',

  // ── Alliance HQ Dialog ────────────────────────────────────
  'alliance_hq.outpost': '前哨站',
  'alliance_hq.station': '空间站',
  'alliance_hq.fortress': '堡垒',
  'alliance_hq.citadel': '要塞',
  'alliance_hq.equal_split': '均分',
  'alliance_hq.rank_weighted': '按等级权重',
  'alliance_hq.activity_weighted': '按活跃权重',
  'alliance_hq.custom': '自定义',

  // ── Station Management Dialog ─────────────────────────────
  'station_mgmt.basic_desc': '基础补给站。储存少，成本低。',
  'station_mgmt.mid_desc': '中级物流枢纽。扩展存储容量。',
  'station_mgmt.fort_desc': '重型防御前哨。防御力强。',
  'station_mgmt.capital_desc': '大型指挥站。最大储存和部署能力。',
  'station_mgmt.hp': '生命值',
  'station_mgmt.storage': '存储',
  'station_mgmt.owned_stations': '已拥有空间站',
  'station_mgmt.no_stations': '尚未拥有空间站',
  'station_mgmt.get_started': '购买上方的空间站开始',

  // ── Wreckage Dialog — time formatting ────────────────────
  'time.days': '天',
  'time.hours': '时',
  'time.minutes': '分',
  'time.expired': '已过期',

  // Crew tab
  'crew.loading': '正在加载船员...',
  'crew.none_assigned': '未分配船员',
  'crew.skill_combat': '战斗',
  'crew.skill_piloting': '驾驶',
  'crew.skill_navigation': '导航',
  'crew.skill_engineering': '工程',
  'crew.skill_science': '科学',

  // ── Leaderboard ────────────────────────────────────────────
  'nav.leaderboard': '排行榜',
  'dialog.leaderboard': '联盟排行榜',
  'leaderboard.rank': '排名',
  'leaderboard.alliance': '联盟',
  'leaderboard.prestige': '威望',
  'leaderboard.territory': '领地',
  'leaderboard.members': '成员',
  'leaderboard.hq_tier': '总部等级',
  'leaderboard.no_data': '暂无联盟数据。',
  'leaderboard.refresh': '刷新',
};
